import { ChangeEvent, useRef } from "react";
import ImageCard from "./imageCard";
import { ImageItem } from "../../pages/product/editProduct";
import { getImageSrc } from "../../helpers/helper";

interface ProductImagesProps {
  productImages: ImageItem[];
  setProductImages: React.Dispatch<React.SetStateAction<ImageItem[]>>;

  productDemoImages: ImageItem[];
  setProductDemoImages: React.Dispatch<React.SetStateAction<ImageItem[]>>;

  onRemoveProductImage: (item: ImageItem) => void;
  onRemoveDemoImage: (item: ImageItem) => void;
}

export default function ProductImages({
    productImages,
    setProductImages,
    productDemoImages,
    setProductDemoImages,

    onRemoveProductImage,
    onRemoveDemoImage,
}: ProductImagesProps){


 

  const imageInputRef = useRef<HTMLInputElement>(null);
  const profileInputRef = useRef<HTMLInputElement>(null);

  const MAX_IMAGES = 3;

  const MAX_PROFILE_IMAGES = 1;

 const handleUploadImages = (e: ChangeEvent<HTMLInputElement>) => {
   const selectedFiles = Array.from(e.target.files ?? []);

   if (selectedFiles.length === 0) return;

   setProductImages((prev) => {
     const remaining = MAX_IMAGES - prev.length;

     if (remaining <= 0) return prev;

     return [...prev, ...selectedFiles.slice(0, remaining)];
   });

   if (imageInputRef.current) {
     imageInputRef.current.value = "";
   }
 };

 const handleRemoveImage = (item: ImageItem) => {
   onRemoveProductImage(item);
 };
  
   const handleRemoveDemoImage = (item: ImageItem) => {
     onRemoveDemoImage(item);
   };

  const handleUploadDemoImages = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(e.target.files ?? []);

    if (selectedFiles.length === 0) return;

    setProductDemoImages((prev) => {
      const remaining = MAX_PROFILE_IMAGES - prev.length;

      if (remaining <= 0) return prev;

      return [...prev, ...selectedFiles.slice(0, remaining)];
    });

    if (profileInputRef.current) {
      profileInputRef.current.value = "";
    }
  };

 

  return (
    <div className="space-y-8">
      {/* Product Images */}
      <div>
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Product Images</h2>

          <span className="text-sm font-medium text-gray-500">
            {productImages.length}/{MAX_IMAGES}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <label
            className={`flex h-44 flex-col items-center justify-center rounded-2xl border-2 border-dashed transition ${
              productImages.length >= MAX_IMAGES
                ? "cursor-not-allowed border-gray-200 bg-gray-100"
                : "cursor-pointer border-gray-300 hover:border-blue-500 hover:bg-blue-50"
            }`}>
            <div
              className={`mb-2 text-4xl ${
                productImages.length >= MAX_IMAGES
                  ? "text-gray-300"
                  : "text-gray-400"
              }`}>
              +
            </div>

            <p
              className={`text-sm font-medium ${
                productImages.length >= MAX_IMAGES
                  ? "text-gray-400"
                  : "text-gray-600"
              }`}>
              {productImages.length >= MAX_IMAGES
                ? "Maximum 3 Images"
                : "Upload Images"}
            </p>

            <input
              ref={imageInputRef}
              type="file"
              multiple
              accept="image/*"
              className="hidden"
              onChange={handleUploadImages}
              disabled={productImages.length >= MAX_IMAGES}
            />
          </label>

          {productImages.map((item, index) => (
            <ImageCard
              key={item instanceof File ? `${item.name}-${index}` : item.id}
              image={getImageSrc(item)}
              onDelete={() => handleRemoveImage(item)}
            />
          ))}
        </div>
      </div>

      {/* Profile Image */}
      <div>
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Profile Images</h2>

          <span className="text-sm font-medium text-gray-500">
            {productDemoImages.length}/{MAX_PROFILE_IMAGES}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <label
            className={`flex h-44 flex-col items-center justify-center rounded-2xl border-2 border-dashed transition ${
              productDemoImages.length >= MAX_PROFILE_IMAGES
                ? "cursor-not-allowed border-gray-200 bg-gray-100"
                : "cursor-pointer border-gray-300 hover:border-blue-500 hover:bg-blue-50"
            }`}>
            <div
              className={`mb-2 text-4xl ${
                productDemoImages.length >= MAX_PROFILE_IMAGES
                  ? "text-gray-300"
                  : "text-gray-400"
              }`}>
              +
            </div>

            <p
              className={`text-sm font-medium ${
                productDemoImages.length >= MAX_PROFILE_IMAGES
                  ? "text-gray-400"
                  : "text-gray-600"
              }`}>
              {productDemoImages.length >= MAX_PROFILE_IMAGES
                ? "Maximum 1 Images"
                : "Upload Profile Images"}
            </p>

            <input
              ref={profileInputRef}
              type="file"
              multiple
              accept="image/*"
              className="hidden"
              onChange={handleUploadDemoImages}
              disabled={productDemoImages.length >= MAX_PROFILE_IMAGES}
            />
          </label>

          {productDemoImages.map((item, index) => (
            <ImageCard
              key={item instanceof File ? `${item.name}-${index}` : item.id}
              image={getImageSrc(item)}
              onDelete={() => handleRemoveDemoImage(item)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
